import React from 'react';
import { Link } from 'react-router-dom';

const NavBrand = () => {
    return (
        <Link to="/" className="flex items-center space-x-4">
            <img className="w-12 select-none" src="../../assets/favicon.png" alt="logo" />
            <h1
                className="text-4xl font-semibold brand-font select-none"
                style={{ color: '#c77eae' }}
            >
                ParaGaïa
            </h1>
        </Link>
    );
};

export default NavBrand;
